import { render, staticRenderFns } from "./_InvoiceHistory.vue?vue&type=template&id=e10f2d06"
import script from "./_InvoiceHistory.vue?vue&type=script&lang=js"
export * from "./_InvoiceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports